module.exports = __webpack_public_path__ + "static/media/secao-4-bg.96737aa0.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/secao-4-bg.png
// module id = 912
// module chunks = 5